import { Calendar, PersonDoc, ProjectDoc } from 'common';
import { ConcourseDb } from '../../global';
import { authFetch } from '../../global/service/AuthService';
import { CalendarUtils } from 'src/components/concourse-schedule/utils/CalendarUtils';

export class ProjectService {
  /**
   * Get the project database instance
   */
  static getProjectDb(projectId: string): ConcourseDb {
    return ConcourseDb.getInstance(`p-${projectId}`);
  }

  /**
   * Get a synced project database instance
   */
  static async getSyncProjectDb(projectId: string): Promise<ConcourseDb> {
    return ConcourseDb.getInstanceSynced(`p-${projectId}`);
  }
  /**
   * Get project document by ID
   */
  static async getProjectDoc(projectId: string): Promise<ProjectDoc> {
    const db = this.getProjectDb(projectId);
    const cached = await db.getDocById(projectId);
    if (cached) {
      return cached;
    }
    await db.syncRemote();
    return await db.getDocByIdAwaitSync(projectId);
  }

  /**
   * Get project document from cache without syncing
   */
  static async getProjectCached(projectId: string): Promise<ProjectDoc | null> {
    const db = this.getProjectDb(projectId);
    const docs = await db.getDocs();
    return docs && docs.length > 0 ? docs[0] : null;
  }

  /**
   * Save project document
   */
  static async saveProjectDoc(doc: ProjectDoc): Promise<ProjectDoc> {
    const db = this.getProjectDb(doc._id);
    return await db.saveDoc(doc);
  }

  /**
   * Fetch person data for a project document
   */
  static async fetchPerson(projectId: string, documentId: string): Promise<PersonDoc> {
    const url = globalThis.ccLambdaBaseUrl + '/fn/projects/fetch-person';
    const response = await authFetch(url + '?' + new URLSearchParams({ projectId, documentId }));
    return response.json();
  }

  /**
   * Get attachment URL from project database
   */
  static async getAttachmentUrl(projectId: string, docId: string, attachmentName: string): Promise<string> {
    const db = this.getProjectDb(projectId);
    return await db.getAttachmentUrl(docId, attachmentName);
  }
}
